module.exports = __webpack_public_path__ + "static/media/calendar-purple.bcd1d99d.svg";